import { useBilingual } from "@/lib/bilingual";
import { asset } from "@/lib/asset";

const FactoryGallery = () => {
  const b = useBilingual();
  const galleryImages = [
    {
      src: asset("/editorial/factory-gallery-1.jpg"),
      alt: b("Grinding and polishing a stone tabletop edge", "石材檯面邊緣研磨拋光"),
      span: "lg:col-span-2 lg:row-span-2",
      height: "h-72 lg:h-full",
    },
    {
      src: asset("/editorial/factory-gallery-2.jpg"),
      alt: b("Hand-finishing a wood tabletop", "木質桌面手工上漆"),
      span: "",
      height: "h-52",
    },
    {
      src: asset("/editorial/factory-gallery-3.jpg"),
      alt: b("Sanding a surface to a smooth finish", "檯面手工打磨修整"),
      span: "",
      height: "h-52",
    },
    {
      src: asset("/editorial/factory-gallery-4.jpg"),
      alt: b("Welding a stainless-steel frame", "不鏽鋼框架焊接"),
      span: "",
      height: "h-52",
    },
    {
      src: asset("/editorial/factory-gallery-5.jpg"),
      alt: b("Sanding a curved timber component", "曲木部件手工打磨"),
      span: "",
      height: "h-52",
    },
  ];
  return (
    <section className="py-14 md:py-24 bg-stone-900">
      <div className="max-w-screen-xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-12">
          <div>
            <p className="text-amber-500 text-xs font-semibold tracking-widest uppercase mb-3">
              {b("Inside the Factory", "走進工廠")}
            </p>
            <h2
              className="text-3xl md:text-5xl font-bold text-white"
              style={{ fontFamily: "var(--font-display)" }}
            >
              {b("A Closer Look", "近距離觀察")}
            </h2>
          </div>
        </div>

        {/* Mosaic grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3" style={{ gridAutoRows: "200px" }}>
          {galleryImages.map((img, idx) => (
            <div
              key={idx}
              className={`relative overflow-hidden rounded-xl group ${img.span}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors duration-300" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FactoryGallery;
